import * as yup from 'yup';

const currency = {
  base: yup.number().typeError('errorMessages.currency')
};
currency.required = currency.base.required('errorMessages.required');
currency.optional = currency.base;

export default currency;
